import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Button, InlineStack, Popover, Select, Text } from "@shopify/polaris";
import { CalendarIcon } from "@shopify/polaris-icons";

import { DATE_RANGE_OPTIONS } from "app/dashboard/modules/operator/dashboardConfig";

const DashboardHeader = ({ title = "Marketplace Dashboard" }) => {
  const [dateRange, setDateRange] = useState(DATE_RANGE_OPTIONS[0].value);
  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopover = useCallback(() => setPopoverActive((active) => !active), []);

  const selectedLabel = DATE_RANGE_OPTIONS.find((opt) => opt.value === dateRange)?.label || "Last 7 Days";

  const activator = (
    <Button icon={CalendarIcon} onClick={togglePopover} disclosure>
      {selectedLabel}
    </Button>
  );

  return (
    <div className="operator-dashboard-header">
      <InlineStack align="space-between" blockAlign="center" wrap={false}>
        <InlineStack gap="300" blockAlign="center">
          <Text as="h1" variant="headingLg" fontWeight="bold">
            {title}
          </Text>
          <span className="operator-dashboard-live-badge">
            <span className="operator-dashboard-live-dot" />
            <Text as="span" variant="bodySm">
              Live
            </Text>
          </span>
        </InlineStack>
        <Popover active={popoverActive} activator={activator} onClose={togglePopover} preferredAlignment="right">
          <div className="operator-dashboard-date-popover">
            <Select label="Date range" options={DATE_RANGE_OPTIONS} value={dateRange} onChange={setDateRange} />
          </div>
        </Popover>
      </InlineStack>
    </div>
  );
};

DashboardHeader.propTypes = {
  title: PropTypes.string,
};

export default DashboardHeader;
